import axios from "axios";

import { WaitingListResponse } from "./generatedTypes";

const WaitingListApi = {
  waitingList: () => axios.get<WaitingListResponse>(`/waiting-list`),
  addToWaitingList: (scmId: string) =>
    axios.post<WaitingListResponse>("/waiting-list", { scm_id: scmId }),
  deleteFromWaitingList: (id: number) =>
    axios.delete<WaitingListResponse>(`/waiting-list/${id}`),
};

export default WaitingListApi;
